import React, { forwardRef } from 'react';
export function ToastDescription(StyledToastDescription) {
    return forwardRef(({ children, ...props }, ref) => {
        return (<StyledToastDescription {...props} ref={ref}>
        {children}
      </StyledToastDescription>);
    });
}
